import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const AccessDenied = () => {
  const { t } = useTranslation('common');
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center px-4 text-center">
      <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-warning-100 text-warning-800">
        <ShieldOff className="h-7 w-7" aria-hidden />
      </div>
      <h1 className="text-lg font-semibold text-gray-900">{t('accessDeniedTitle')}</h1>
      <p className="mt-2 max-w-md text-sm text-gray-600">
        {t('accessDeniedBody')}
      </p>
      <Link
        to="/"
        className="btn btn-primary mt-6 inline-flex items-center gap-2"
      >
        {t('goHome')}
      </Link>
    </div>
  );
};

export default AccessDenied;
